/* 3rd party libraries */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatSidenavModule,
  MatIconModule,
  MatMenuModule,
  MatToolbarModule,
  MatListModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatDialogModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatProgressBarModule,
  MatCheckboxModule,
  MatCardModule,
  MatOptionModule,
  MatSelectModule,
  MatTabsModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatStepperModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatRadioModule
} from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { NumberPickerModule } from '@retailify/ngx-mat-numberpicker';
import { YearoldPipe } from './pipes/yearold.pipe';
import { PaymentMethodPipe } from './pipes/payment-method.pipe';
import { OrderStatusPipe } from './pipes/order-status.pipe';

/* our own custom components */

@NgModule({
  declarations: [YearoldPipe, PaymentMethodPipe, OrderStatusPipe],
  imports: [
    /* angular stuff */
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    /* 3rd party components */
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatListModule,
    MatInputModule,
    FlexLayoutModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    LoadingBarRouterModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MaterialFileInputModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatSelectModule,
    MatCardModule,
    MatOptionModule,
    MatSelectModule,
    MatTabsModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NumberPickerModule,
    MatRadioModule
  ],
  exports: [
    /* angular stuff */
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    /* 3rd party components */
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatListModule,
    FlexLayoutModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    LoadingBarRouterModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MaterialFileInputModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatSelectModule,
    MatCardModule,
    MatOptionModule,
    MatSelectModule,
    MatTabsModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NumberPickerModule,
    MatRadioModule,
    /* our own custom components */
    YearoldPipe,
    PaymentMethodPipe,
    OrderStatusPipe
  ]
})
export class SharedModule {}
